import { StyleSheet } from "react-native";
import { theme } from "../../../../../theme/theme";
const HEADER_HEIGHT = 48;
const style = () => {
    const { colorBgBase, space2, space10 } = theme();
    return StyleSheet.create({
        button: {
            alignSelf: "auto",
            height: space10,
            width: space10,
        },
        buttonIconPlaceholder: {
            flexGrow: 0,
            height: space10,
            width: space10,
        },
        header: {
            alignItems: "center",
            backgroundColor: colorBgBase,
            flexDirection: "row",
            flexGrow: 0,
            flexWrap: "nowrap",
            height: HEADER_HEIGHT,
            justifyContent: "space-between",
            overflow: "visible",
            paddingHorizontal: space2,
            width: "100%",
        },
    });
};
export { style };
